import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const ArrowRightIcon: React.FC<IconProps> = ({ color, size, ...rest }) => {
  return (
    <Icon color={color} size={size} {...rest}>
      <path d="M8.94141 0.921875L8.39453 1.46875C8.28516 1.60547 8.28516 1.79688 8.42188 1.93359L10.6094 4.03906H1.20312C1.01172 4.03906 0.875 4.20312 0.875 4.36719V5.13281C0.875 5.32422 1.01172 5.46094 1.20312 5.46094H10.6094L8.42188 7.59375C8.28516 7.73047 8.28516 7.92188 8.39453 8.05859L8.94141 8.60547C9.07812 8.71484 9.26953 8.71484 9.40625 8.60547L13.0156 4.99609C13.125 4.85938 13.125 4.66797 13.0156 4.53125L9.40625 0.921875C9.26953 0.8125 9.07812 0.8125 8.94141 0.921875Z" />
    </Icon>
  );
};
